import { combineReducers } from "redux";
import { Notification, RecentCalls } from "src/common/types";

export default combineReducers({
  notifications: (state: Notification[] = [], action) => {
    switch (action.type) {
      case "PUSH_NOTIFICATION":
        const { notification } = action;
        return state.concat(notification);
      case "POP_NOTIFICATION":
        return state.slice(1);
      default:
        return state;
    }
  },
  isOnline: (state: boolean = navigator.onLine, action) => {
    switch (action.type) {
      case "DEVICE_ONLINE":
        return true;
      case "DEVICE_OFFLINE":
        return false;
      default:
        return state;
    }
  },
  recentCalls: (state: RecentCalls = {}, action) => {
    const resId = (action.resident && action.resident.id) || "manager";
    switch (action.type) {
      case "INCREMENT_RECENT_CALL":
        return { ...state, [resId]: state[resId] ? state[resId] + 1 : 1 };
      case "DECREMENT_RECENT_CALL":
        return {
          ...state,
          [resId]: state[resId] && state[resId] > 0 ? state[resId] - 1 : 0,
        };
      default:
        return state;
    }
  },
});
